<template>

  <b-card
    class="mb-1"
    style="margin:0;border:1px solid #c9c9c9;"
  >
    <b-card-header
      header-tag="header" 
      role="tab"
      block 
      @click="visibleBody = !visibleBody"
      style="padding:0; cursor: pointer;"
    >
      <span class="mr-5">AIEPI</span>
      <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
    </b-card-header>
    <b-collapse 
      v-model="visibleBody" 
      id="collapse-4"
    >
      <b-card-body>

        <fieldset :disabled="onlyView">

          <div>
            <!-- <label><b>Edad seleccionada: 0 a 2 meses</b></label> -->
  
            <b-form-checkbox-group 
              v-model="aiepi.itemsChecked" 
              :options="itemsOpts" 
              plain
            />
  
            <div 
              v-for="(item) in aiepi.itemsList" 
              :key="item.value"
              class="row my-2 d-flex align-items-center"
            >
              <div class="col-sm-3">
                <label>{{ item.text }}</label>
              </div>
  
              <div class="col-sm-8">
                <b-form-input
                  v-model="item.inputText"
                  placeholder="Describa el examen fisico..."
                  type="text"
                />
              </div> 
              
            </div>
          </div>
             
          <b-row class="mt-1">
            <b-col>
              <label><b>Hallazgos: </b></label>
              <b-form-textarea v-model="aiepi.hallazgos"/>
            </b-col>
          </b-row>

        </fieldset>
    
      </b-card-body>
    </b-collapse>

  </b-card>

</template>

<script>
import { addNewOpt } from '@/shared/helpers';
import { mapState } from "vuex";

export default {

  name: 'Aiepi',


  props: {
    onlyView: {
      type: Boolean,
      default: false
    }
  },


  data() {
    return {
      
      visibleBody: false,
      edadEnMeses: null,
      itemsOpts: [],
      
      aiepi:{
        itemsChecked:[],
        itemsList:[],
        hallazgos:''
      },

      edad1Opts: [
        { value: "1", text: "Signos de enfermedad muy grave o infección local" },
        { value: "2", text: "Ictericia" },
        { value: "3", text: "Diarrea" },
        { value: "4", text: "Problema de alimentación o bajo peso" },
        { value: "5", text: "Recibió BCG" },
        { value: "6", text: "Recibió HB" },
        { value: "7", text: "Maltrato" },
        { value: "8", text: "Problema de desarrollo psicomotor" },
        { value: "9", text: "Otro problema" },
      ],

      edad2Opts: [
        { value:"0",  text:"Signos de peligro en general" },
        { value:"1",  text:"Tos o dificultad respiratoria" },
        { value:"2",  text:"Diarrea" },
        { value:"3",  text:"Fiebre" },
        { value:"4",  text:"Problema del oído" },
        { value:"5",  text:"Problema de la garganta" },
        { value:"6",  text:"Desnutrición aguda" },
        { value:"7",  text:"Sobrepeso / Obesidad" },
        { value:"8",  text:"Talla baja" },
        { value:"9",  text:"Tendencia crecimiento apropiada" },
        { value:"10", text:"Anemia" },
        { value:"11", text:"Requiere administración de vitamina A" },
        { value:"12", text:"Requiere administración de micronutrientes en polvo" },
        { value:"13", text:"Requiere administración de hierro" },
        { value:"14", text:"Requiere administración de albendazol" },
        { value:"15", text:"Otros problemas" },
        { value:"16", text:"Maltrato infantil" },
        { value:"17", text:"Problemas de desarrollo psicomotor" },
        { value:"18", text:"Falta vacunas" },
        { value:"19", text:"Problemas de salud oral" },
        { value:"20", text:"Riesgo social" },
      ],

    }
  },

  methods: {
    onAddNewOpt(newArray) {
      return addNewOpt(newArray);
    },


    setOptsPorEdad(fechaNacimiento) {

      const fechaInicio = new Date(fechaNacimiento);
      const fechaActual = new Date();

      const años  = fechaActual.getFullYear() - fechaInicio.getFullYear();
      let meses   = fechaActual.getMonth() - fechaInicio.getMonth();
      const dias  = fechaActual.getDate() - fechaInicio.getDate();

      // Ajustar si el día actual es menor al día de inicio
      if (dias < 0) {
        meses -= 1;
      }

      const totalMeses = años * 12 + meses;
      const edadEnMeses = totalMeses >= 0 ? totalMeses : 0;

      if(edadEnMeses >= 0 && edadEnMeses <= 2){
        this.itemsOpts = this.edad1Opts;
      }

      const meses5anos = 12 * 5;
      if(edadEnMeses > 2 && edadEnMeses <= meses5anos){
        this.itemsOpts = this.edad2Opts;
      }

      if(edadEnMeses > meses5anos){
        // this.rangoEdad = { value: '3', text: '5 a 9 anos' }
      }
      
    },


    resetAiepi(){
      this.aiepi = {
        itemsChecked : [],
        itemsList    : [],
        hallazgos    : ''
      }
    }
  },


  computed: {

    ...mapState({
      stFechaNacimiento : state => state.atencionCita.dataCita?.paciente?.persona?.fechaNacimiento,
      stFechaCita       : state => state.atencionCita.dataCita?.fechaCita,
      stSemPediatrica   : state => state.atencionCita.semiologias?.semPediatrica,
      stSemiologiaView  : state => state.atencionMedica.dataAtencion.semiologiaView
    }),

  },


  watch: {

    'aiepi.itemsChecked':{
      deep: true,
      handler(){
        this.aiepi.itemsList = this.aiepi.itemsList.filter(
          item => this.aiepi.itemsChecked.includes( item.value )
        );


        this.aiepi.itemsChecked.forEach( id => {  
          if(!this.aiepi.itemsList.some( item => item.value === id)){
            const newItem = this.itemsOpts.find( item => item.value === id );

            this.aiepi.itemsList.push({
              // id       : newItem.id || null,
              value    : newItem.value,
              text     : newItem.text,
              inputText: '',
            });
          }
        });
      }
    },


    stFechaNacimiento: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.setOptsPorEdad(newValue)
      }
    },


    stSemPediatrica:{
      immediate: true,
      deep: true,

      handler(newVal) {
        const tokenAtencion = this.$route.params.token;
        if(!tokenAtencion && !this.onlyView) return;

        if (newVal.aiepi) {
          this.aiepi = newVal.aiepi;
        }
      }
    },


    stSemiologiaView:{
      immediate: true,
      // deep: true,
      handler(newValue){

        if(!this.onlyView) return;

        this.resetAiepi();
        if (newValue?.aiepi) this.aiepi = newValue.aiepi
      }
    },


    aiepi:{
      deep:true,
      handler(newValue){
        if(this.onlyView) return;
        this.$store.commit("setAiepi", newValue)
      }
    }

  },

}
</script>